'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.browser = exports.isDesktop = exports.isMobile = exports.isAndroid = exports.isIpad = exports.isIphone = undefined;

var _log = require('babel-runtime/core-js/math/log2');

var _log2 = _interopRequireDefault(_log);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

exports.choice = choice;
exports.mod = mod;
exports.norm = norm;
exports.requestAudioContext = requestAudioContext;
exports.dataURItoBlob = dataURItoBlob;
exports.ftom = ftom;
exports.mtof = mtof;
exports.tap = tap;
exports.get_diff_bounds = get_diff_bounds;
exports.get_bounds = get_bounds;
exports.transpose = transpose;

var _tone = require('tone');

var _tone2 = _interopRequireDefault(_tone);

var _startAudioContext = require('./startAudioContext');

var _startAudioContext2 = _interopRequireDefault(_startAudioContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isIphone = exports.isIphone = navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i);
var isIpad = exports.isIpad = navigator.userAgent.match(/iPad/i);
var isAndroid = exports.isAndroid = navigator.userAgent.match(/Android/i);
var isMobile = exports.isMobile = isIphone || isIpad || isAndroid;
var isDesktop = exports.isDesktop = !isMobile;

document.body.classList.add(isMobile ? 'mobile' : 'desktop');

var browser = exports.browser = { isIphone: isIphone, isIpad: isIpad, isMobile: isMobile, isDesktop: isDesktop };

function choice(a) {
  return a[Math.floor(Math.random() * a.length)];
}
function mod(n, m) {
  return n - m * Math.floor(n / m);
}
function norm(n, min, max) {
  return (n - min) / (max - min);
}

function requestAudioContext(fn) {
  if (isMobile) {
    var container = document.createElement('div');
    var button = document.createElement('div');
    button.innerHTML = 'Tap to start - please unmute your phone';
    (0, _assign2.default)(container.style, {
      position: 'absolute',
      width: '100%',
      height: '100%',
      zIndex: '10000',
      top: '0px',
      left: '0px',
      backgroundColor: 'rgba(0, 0, 0, 0.8)'
    });
    (0, _assign2.default)(button.style, {
      position: 'absolute',
      left: '50%',
      top: '50%',
      padding: '20px',
      backgroundColor: '#7F33ED',
      color: 'white',
      fontFamily: 'monospace',
      borderRadius: '3px',
      transform: 'translate3D(-50%,-50%,0)',
      textAlign: 'center',
      lineHeight: '1.5'
    });
    container.appendChild(button);
    document.body.appendChild(container);
    _startAudioContext2.default.setContext(_tone2.default.context);
    _startAudioContext2.default.on(button);
    _startAudioContext2.default.onStarted(function (_) {
      container.remove();
      fn();
    });
  } else {
    fn();
  }
}

function dataURItoBlob(dataURI) {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  var byteString = atob(dataURI.split(',')[1]);

  // separate out the mime component
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  // write the bytes of the string to an ArrayBuffer
  var ab = new ArrayBuffer(byteString.length);

  // create a view into the buffer
  var ia = new Uint8Array(ab);

  // set the bytes of the buffer to the correct values
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  // write the ArrayBuffer to a blob, and you're done
  var blob = new Blob([ab], { type: mimeString });
  return blob;
}
function ftom(f) {
  // return (Math.log(f) - Math.log(261.626)) / Math.log(2) + 4.0
  return 69 + 12 * (0, _log2.default)(f / 440);
}
function mtof(m) {
  return 440 * Math.pow(2, (m - 69) / 12);
}
function tap(fn) {
  return function (e) {
    if (browser.isMobile) fn();else if (e.press) fn();
  };
}

/* get minimum and maximum variance from row-to-row */

function get_diff_bounds(rows) {
  var diffs = rows.map(function (row) {
    var row_min = Math.min.apply(Math, row);
    var row_max = Math.max.apply(Math, row);
    return row_max - row_min;
  });
  var min = Math.min.apply(Math, diffs);
  var max = Math.max.apply(Math, diffs);
  return { min: min, max: max };
}

/* get minimum and maximum values from a dataset */

function get_bounds(dataset) {
  var rows = dataset.lines;
  // rows.forEach(row => row.shift())
  rows = rows.map(function (a) {
    return a.map(function (n) {
      return parseFloat(n);
    });
  });
  var max = rows.reduce(function (a, b) {
    return b.reduce(function (z, bb) {
      return Math.max(z, bb);
    }, a);
  }, -Infinity);
  var min = rows.reduce(function (a, b) {
    return b.reduce(function (z, bb) {
      return Math.min(z, bb);
    }, a);
  }, Infinity);
  return { rows: rows, max: max, min: min };
}

/* transpose a 2D array */

function transpose(a) {
  var i_len = a[0].length;
  var j_len = a.length;
  var T = new Array(i_len);
  for (var i = 0; i < i_len; i++) {
    T[i] = new Array(j_len);
    for (var j = 0; j < j_len; j++) {
      T[i][j] = a[j][i];
    }
  }
  return T;
}


//////////////////
// WEBPACK FOOTER
// ./client/lib/util.js
// module id = 44
// module chunks = 0